module.exports = __webpack_public_path__ + "static/media/SF_bm_primaerlogo_nordland_neg.38118742.svg";